import o from "dayjs";
import { dayjsToDateTimeString as T } from "../../../helpers/date-helper.js";
const n = {
  step: "SHOW_SEARCH_WIDGET",
  trailerTypeFilter: null,
  hasTriggeredAutoSearch: !1
};
function s(a, e) {
  switch (e.type) {
    case "SET_HAS_TRIGGERED_AUTOSEARCH":
      return { ...a, hasTriggeredAutoSearch: !0 };
    case "CHANGE_STEP":
      return { ...a, step: e.payload.step };
    case "SET_AVAILABLE_STATIONS": {
      const r = e.payload.selectedStationId ? e.payload.stations.find((l) => l.locationId.toString() === e.payload.selectedStationId) : void 0;
      return {
        ...a,
        availableStations: e.payload.stations,
        selectedStation: r,
        nearbyStations: e.payload.nearbyStations
      };
    }
    case "SET_AVAILABLE_TRAILERS":
      return {
        ...a,
        availableTrailers: e.payload.trailers,
        nearbyAvailableTrailers: e.payload.nearbyTrailers
      };
    case "SELECT_STATION":
      return { ...a, selectedStation: e.payload.station, nearbyStations: e.payload.nearbyStations };
    case "SELECT_RENTAL_DATE": {
      const r = e.payload.rentalStartDate, l = e.payload.rentalEndDate;
      let d = r || a.selectedRentalStartDate, t = l || a.selectedRentalEndDate;
      return r && t && o(r).isAfter(o(t)) && (t = r), r === null && (d = void 0), l === null && (t = void 0), { ...a, selectedRentalStartDate: d, selectedRentalEndDate: t };
    }
    case "SELECT_TRAILER":
      return { ...a, step: "SELECT_TIMESLOT_FOR_TRAILER", selectedTrailer: e.payload.trailer };
    case "DESELECT_TRAILER":
      return {
        ...a,
        step: "LIST_AVAILABLE_TRAILERS",
        selectedTrailer: void 0,
        selectedFromSlot: void 0,
        selectedToSlot: void 0
      };
    case "SELECT_TRAILER_TYPE_FILTER":
      return { ...a, trailerTypeFilter: e.payload.trailerType };
    case "SELECT_FROM_TIMESLOT": {
      const r = o(e.payload.timeSlot);
      let l = o(a.selectedToSlot);
      return r && l && (l.isBefore(r, "minute") || l.isSame(r, "minute")) && (l = void 0), {
        ...a,
        selectedFromSlot: T(r),
        selectedToSlot: l ? T(l) : void 0
      };
    }
    case "SELECT_TO_TIMESLOT":
      return {
        ...a,
        selectedToSlot: e.payload.timeSlot
      };
    case "BOOKING_COMPLETED":
      return {
        ...a,
        bookingId: e.payload.bookingId,
        customerEmail: e.payload.customerEmail,
        step: "BOOKING_COMPLETED"
      };
    case "SET_PERSONAL_INFORMATION_FORM":
      return {
        ...a,
        personalInformationForm: e.payload.personalInformationForm
      };
    default:
      return { ...a };
  }
}
export {
  n as InitialTrailerRentalState,
  s as TrailerRentalReducer
};
